import { AuthContext } from "@providers/AuthProvider"
import React, { useState } from "react"
import NavDropdown from "react-bootstrap/esm/NavDropdown"
import UserMenuItem from "@components/UserMenu/UserMenuItem"
import Localization from "@localization/Index"
import styles from './css/UserMenu.module.scss'
import BaseAvatar from "./BaseAvatar"
import SupportAvatar from "./SupportAvatar"
import { UserRoleEnum } from "cs.node.utils/RoleUtils"
import { useMobileMediaQuery } from "@utils/MediaComponents"
import { Offcanvas } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { askConfirmation, showError } from "@utils/NotificationsUtils"
import HeaderLanguage from "@components/Header/HeaderLanguage"
import SideMenu from "@components/SideMenu/SideMenu"

const UserMenu = () =>{
    const [showMenu, setShowMenu] = useState(false)
    const auth = React.useContext(AuthContext)
    const navigate = useNavigate()
    const isMobile = useMobileMediaQuery()
    const { userData } = auth
    const { companyname, firstname, lastname, username } = userData

    const mainName = firstname && lastname ? `${firstname} ${lastname}`:companyname

    const avatar = (userData.role === UserRoleEnum.SUPPORT) ? <SupportAvatar avatarLink={userData.avatar_link} shortIdentifier={userData.shortIdentifier} /> :  <BaseAvatar avatarLink={userData.avatar_link} />

    const doLogout = async()=>{
        try{
            const askResponse = await askConfirmation({
                html: Localization.CONFERMA_LOGOUT
            })

            if(!askResponse.isConfirmed) {
                return
            }

            return navigate('/logout')
        } catch(err) {
            showError(Localization.ERRORE_GENERICO, err)
        }
    }
    
    if(isMobile) {
        return <>
        <div onClick={()=>setShowMenu(true)}>{avatar}</div>
        <Offcanvas show={showMenu} onHide={() => setShowMenu(false)} placement="end" scroll={false} backdropClassName="offcanvas-custom-backdrop" backdrop={true} style={{ zIndex: 9999 }}>
            <Offcanvas.Header closeButton />
            <Offcanvas.Body>
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <div className="d-flex align-items-start justify-content-start">
                            {avatar}
                            <div className="d-flex flex-column ms-4">
                                <span className={styles.mainName}>{mainName}</span>
                                <span className={`text-muted ${styles.username}`}>{username}</span>
                                <div className="d-flex">
                                    <span className="text-decoration-underline text-gray-900 fs-5 mt-4" onClick={()=>doLogout()}>{Localization.LOGOUT}</span>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center justify-content-end">
                            <HeaderLanguage />
                        </div>
                    </div>
                    <hr className="my-5" />
                    <SideMenu onClose={()=>setShowMenu(false)} />
            </Offcanvas.Body>
        </Offcanvas>
        </>
    }

    return (
        <div className="d-flex align-items-center">
            <div className="d-flex flex-column align-items-left">
                <NavDropdown align={"end"} id="cs-header-user-dropdown" className={styles.navdropdown} title={avatar}>
                        <NavDropdown.ItemText className="px-3 mb-4">
                            <div className="px-3 pt-2 d-flex align-items-center justify-content-start">
                                {avatar}
                                <div className="ms-4 d-flex flex-column align-items-left justify-content-start">
                                    <span className={styles.mainName}>{mainName}</span>
                                    <span className={`text-muted ${styles.username}`}>{username}</span>
                                </div>
                            </div>
                        </NavDropdown.ItemText>
                        <UserMenuItem to="/profile" label={Localization.MENU.PROFILO} />
                        <NavDropdown.Divider className={styles.separator} />
                        <UserMenuItem to="/logout" label={Localization.LOGOUT} />
                </NavDropdown>
            </div>
        </div>
    )
}

export default UserMenu